import _          from 'lodash';
import CourseMenu from './course_menu';

export class InvalidMealSelection {
  constructor(courseMenu) {
    this.courseMenu = courseMenu;
    this.name       = this.constructor.name;
    this.stack      = (new Error).stack;
    this.message    = (
      `Invalid selection ${this.courseMenu.selectedMealNumber} ` +
      `from ${this.courseMenu.meals.map(meal => meal.number).toArray()}`
    );
  }
}

InvalidMealSelection.prototype.__proto__ = Error.prototype;

export default class CourseMenuWithOrder extends CourseMenu {
  constructor(canteen, date, course, meals, selectedMealNumber, savedMealNumber) {
    super(canteen, date, course, meals);

    if (selectedMealNumber && !meals.some(meal => meal.number === selectedMealNumber)) {
      throw new InvalidMealSelection(this);
    }

    this.selectedMealNumber = selectedMealNumber;
    this.savedMealNumber    = savedMealNumber;
  }

  selectedMeal() {
    return this.selectedMealNumber && this.meals.find(meal => meal.number === this.selectedMealNumber);
  }

  select(selectedMealNumber) {
    return new this.constructor(this.canteen, this.date, this.course, this.meals, selectedMealNumber, this.savedMealNumber);
  }

  deselect() {
    return new this.constructor(this.canteen, this.date, this.course, this.meals, null, this.savedMealNumber);
  }

  save() {
    return new this.constructor(this.canteen, this.date, this.course, this.meals, this.selectedMealNumber, this.selectedMealNumber);
  }

  cancel() {
    return new this.constructor(this.canteen, this.date, this.course, this.meals, null, null);
  }

  safeSelect(selectedMealNumber) {
    try {
      return this.select(selectedMealNumber);
    } catch (InvalidMealSelection) {
      return this;
    }
  }

  isSaved() {
    return this.savedMealNumber === this.selectedMealNumber;
  }

  hasSelection() {
    return !!this.selectedMealNumber;
  }
}
